import React from "react";
import { usePath } from "@/contexts/path/path";
import css from "./.module.scss";
import Skeleton from "../skeleton";
import { AppLink } from "./app.ink";

export function BreadCrumbHolder({ tow } = {}) {
  return (
    <Skeleton className={css.breadcrumb} style={{}}>
      <Skeleton.Item style={{ width: "10rem", height: "1.5rem" }} />
      <Skeleton.Item style={{ width: "10rem", height: "1.5rem" }} />
      {!tow ? (
        <>
          <Skeleton.Item style={{ width: "10rem", height: "1.5rem" }} />
          <Skeleton.Item style={{ width: "10rem", height: "1.5rem" }} />
        </>
      ) : null}
    </Skeleton>
  );
}
export default function BreadCrumb() {
  const {
    basePath = "",
    homeLabel = "الرئيسية",
    category,
    city,
    direction,
    district,
    resolving,
    updateContext,
    search,
    filterAsPath,
  } = usePath();
  if (resolving) return <BreadCrumbHolder />;

  return (
    <ul className={css.breadcrumb}>
      {category && (
        <>
          <li>
            <AppLink
              path={basePath || "/"}
              onClick={() =>
                updateContext({
                  category: null,
                  city: null,
                  district: null,
                  direction: null,
                  listing: null,
                  page: 0,
                })
              }
            >
              {homeLabel}
            </AppLink>
          </li>
          <li>
            <AppLink
              path={`${basePath || "/"}${category.uri}${filterAsPath || ""}`}
              onClick={() =>
                updateContext({
                  category,
                  city: null,
                  district: null,
                  page: 0,
                  direction: null,
                  listing: null,
                })
              }
            >
              {category.plural}
            </AppLink>
          </li>
        </>
      )}

      {category && city && (
        <li>
          <AppLink
            path={`${basePath || "/"}${category.uri}/${city.uri}${
              filterAsPath || ""
            }`}
            onClick={() =>
              updateContext({
                category,
                city,
                district: null,
                page: 0,

                direction: null,
                listing: null,
              })
            }
          >
            {city.name}
          </AppLink>
        </li>
      )}

      {category && city && direction && (
        <li>
          <AppLink
            path={`${basePath || "/"}${category.uri}/${city.uri}/${
              direction.uri
            }${filterAsPath || ""}`}
            type="button"
            onClick={() =>
              updateContext({
                category,
                city,
                direction,
                district: null,
                page: 0,
                listing: null,
              })
            }
          >
            {direction.name}
          </AppLink>
        </li>
      )}

      {category && city && district && (
        <li>
          <AppLink
            path={`${basePath || "/"}${category.uri}/${city.uri}/${
              direction?.uri ? `${direction.uri}/` : ""
            }${district.uri}`}
            onClick={() =>
              updateContext({
                category,
                city,
                district,
                direction,
                listing: null,
                page: 0,
              })
            }
          >
            {district.name}
          </AppLink>
        </li>
      )}
    </ul>
  );
}
